import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import { environment } from '../environment/production';

function ForgotPassword() {
    const [formdata,setFormData]=useState({
        email_id:''
    })
    const [errormsg,setErrorMsg]=useState({
        email_id:''
    })
    const navigate = useNavigate();
    function handleValidations(e){
        if(e.target.email_id.value==""){
            setErrorMsg({email_id:"Email id can not be blank"})
        }else{
            axios.post(environment.apiUrl+"/UserMng/forgotPassword",JSON.stringify(formdata))
            .then((resp)=>{
              
               if(resp['data']['status']==1){
                alert(resp['data']['msg'])
               }else{
                alert(resp['data']['msg'])
               }
               
            })
            
        }
       
    }
    const handleForgotPassword=(e)=>{
        e.preventDefault();
        formdata.email_id=e.target.email_id.value;
        setFormData(...[formdata])
        handleValidations(e)
    }
  return (
    <>
    <div className="login-page login-page9">   {/* style={{ backgroundImage: `url('./gstn.png')` }} */}
     <div className="login-page9-wrapper">
    
      <form onSubmit={(e)=>handleForgotPassword(e)}>
     
          <header> 
            <h4 className="text-center">Enter Your Registered Email Id To Reset Password</h4>
          </header>
          
          <br/>
          <div style={{color:'red',textAlign:'center'}}>{errormsg.email_id}</div> 
          <label className="rlp-username">
            <input placeholder="Enter Email Id" index="1" name="email_id" />
          </label>
         
          <section>
          <button type="submit">Submit</button></section>
         
      </form>
    </div>
    </div>
    </>
  )
}

export default ForgotPassword